import { RACK_COLORS } from "../../constants"
import { WallMountOptions } from "../../RackTypes"
import { findCustomOption } from "../../utils/product-lookup"
import { WallmountFactory } from "./wallmountFactory"
import { IRogue, BuyRequest } from "@/js/services/RogueTypes"
import { getSimpleForBuyRequest } from "@/js/helpers/buy-request"

// Creates the config for the RML-3WC, RML-3W, RM-3W, RML-90Slim, RML-390FullW
export function createWallMountConfig(rogue: IRogue, buyRequest: BuyRequest): WallMountOptions {
  const rack = getSimpleForBuyRequest(buyRequest, rogue)
  const isRML = rogue.getProductById(Number(buyRequest?.metadata?.groupedProductId)).name.includes('RML')
  const isRML3WC = rogue.getProductById(Number(buyRequest?.metadata?.groupedProductId)).name.includes('RML-3WC')
  const isRML3W = rogue.getProductById(Number(buyRequest?.metadata?.groupedProductId)).name.includes('RML-3W') && !isRML3WC
  const isRM3W = rogue.getProductById(Number(buyRequest?.metadata?.groupedProductId)).name.includes('RM-3W')
  const is390Full = rogue.getProductById(Number(buyRequest?.metadata?.groupedProductId)).name.includes('390FULLW')
  const is90SlimRack = rogue.getProductById(Number(buyRequest?.metadata?.groupedProductId)).name.includes('90SLIM')
  const line = isRML ? 'RML' : 'RM'

  let color = RACK_COLORS[rack.attributes.rig_color as string || 'Satin Black']
  const hardware = String(rack.attributes?.hardware_finish)?.toLowerCase()?.includes('black') ? 'isonite' : 'zinc'
  const depthSelection = Math.floor(Number(rack.attributes.rack_depth?.toString().replace('"', ''))) || 9

  // 390Full has a unique color name not found in RACK_COLORS: Textured Black - Non-numbered Uprights
  if (is390Full && String(rack.attributes.rig_color)?.toLowerCase()?.includes('non-numbered')) {
    color = RACK_COLORS['Textured Black']
  }

  const rmlStringerSelection = isRML3WC || is390Full ? !findCustomOption(rogue, buyRequest, 'stringer')?.includes('No') : !!rack.attributes?.rig_or_wm?.toString()?.includes('Yes')
  const rmStringerSelection = !!rack.attributes.rig_or_wm && rack.attributes.rig_or_wm.toString().includes('Yes')

  const numbered = rack.attributes.edition === 'Numbered' || rack.attributes.upright_type === 'Numbered' || line === 'RM'

  // Not using getJCupSelection() because RM-3W is setup in Magento differently.
  // Can remove when eOps fixes
  const jcup = rack.attributes?.generic_size?.toString()
  let jcupSelection = 'jcup'
  if (jcup?.includes('2')) {
    jcupSelection = 'sandwich jcup 2'
  } else if (jcup?.includes('Sandwich')) {
    jcupSelection = 'sandwich jcup 1'
  }

  // Work arounds for 90SlimnRack until product is changed to a bundle
  const isBracketFor90Slim = rack.attributes.edition?.toString()?.includes('Bracket')
  const isPullupFor90Slim = !!rack.attributes?.sandbag_type?.toString()?.includes('Add')
  
  return {
    line,
    numbered,
    hardware,
    depth    : depthSelection,
    jcup     : isRML ? 'jcup' : jcupSelection,
    color,
    stringer : isRML ? rmlStringerSelection : rmStringerSelection,
    is390Full,
    isRML3W,
    isRM3W,
    is90SlimRack,
    isPullupFor90Slim,
    isBracketFor90Slim,
  }
}

export function createWallMount(rogue: IRogue, buyRequest: BuyRequest) {
  const config = createWallMountConfig(rogue, buyRequest)
  const part = WallmountFactory.build(config)
  
  return { config, part }
}



